<template>
  <!-- 诚信-扣分列表 -->
  <div class="deduct_list">
    <div class="head">
      <div class="head_left flex flex-col">
        <div> {{ title }}</div>
        <div class="flex-row  text-12 text-[#999999] font-400">
          <span> {{ areaName }}</span>
          <span class="ml-8">{{ quarterName }}</span>
        </div>
      </div>
      <div class="head_right">
        <p class="score" :class="isShowDeduction ? '' : 'gray'">
          {{ isShowDeduction || accidentList.length > 0 ? "-" + deduction : "未扣分" }}</p>
        <p class="percent">{{ score }}/{{ sumScore }}</p>
      </div>
    </div>
    <div class="save_list">
      <div v-if="accidentList.length > 0" class="list">
        <div class="list_top">
          <div class="total">
            共
            <span>{{ accidentList.length }}</span> 条扣分记录
          </div>
          <!-- <btnauth custype="apply" :year="year" :quarter="quarter">
            <van-button
              v-if="accidentList.length < 4 && addAuth === 'OPERATION01'"
              @click="addSituation"
              class="add_btn"
              size="small"
              type="primary"
              color="#36B374"
            ><span class="plus">+</span><span>新增</span> </van-button>
          </btnauth> -->
        </div>
        <div class="record_list">
          <div class="record_item" v-for="item in accidentList" :key="item.id">
            <div>
              <div class="record_title">
                <span class="title">{{ item.integrityTypeCN }}</span>
                <span v-if="item.audited == 0" class="status">未扣分</span>
                <span v-if="item.audited == 1" class="deduct_score">-{{ item.deduction / 100 }}分</span>
              </div>
              <div class="reason" v-if="item.audited == 1">
                <template v-if="item.integrityType == 'C2'">
                  <span class="fmemo">未完成业态数量：{{ item.unfinishNum }}</span>
                </template>
                <template v-else>
                  <span style="display: inline-block;">扣分原因：</span>
                  <span class="fmemo">{{ item.deductionReason }}</span>
                </template>
              </div>
              <div class="reason" v-else>
                <template>
                  <span style="display: inline-block;">扣分原因：</span>
                  <span v-if="item.deduction && item.deductionReason">{{ item.deductionReason }}</span>
                  <span v-else>未发生扣分情况</span>
                </template>
              </div>
              <div class="reason" v-if="item.audited == 1">
                <span>发生时间：</span>
                <span>{{ item.deductionTime }}</span>
              </div>
              <div class="see_more" @click="goDetail(item)">
                <span>查看详情</span>
                <img src="@/assets/appraise/ic_jt_ck_l@2x.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="accidentList.length == 0" class="no_data">
        <div class="no_data_img">
          <img src="@/assets/appraise/ic_wuxingxi@2x.png" alt />
        </div>
        <div class="no_data_tip">
          <p>该州市未发生扣分情况</p>
        </div>
        <!-- <btnauth custype="apply" :year="year" :quarter="quarter">
          <div class="add_btn_box">
            <van-button
              v-if="addAuth === 'OPERATION01'"
              @click="addSituation"
              class="add_btns"
              size="small"
              type="primary"
              color="#36B374"
            ><span class="plus">+</span><span>新增</span></van-button>
          </div>
        </btnauth> -->
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/service/modules/appraiseNewWzy.js";
import btnauth from "../appraiseNew/components/btnauth";
import commonAPI from "../../../utils/common";

export default {
  components: {
    btnauth,
  },
  data() {
    return {
      title: "涉旅企业诚信评价进展情况",
      accidentList: [], // 列表
      deduction: 0, // 扣分总数
      score: 0, // 得分
      sumScore: 10, // 总分

      area: this.$route.query.area,
      areaName: this.$route.query.areaName,
      year: this.$route.query.year,
      quarter: this.$route.query.quarter,
      quarterName: this.$route.query.quarterName,
      // 权限字段
      addAuth: "",
      updateAuth: "",
      deleteAuth: "",
      userAuthoirese: "",
    };
  },
  created() {
    const childAuth = commonAPI.getAuthorityList("ASSESS_SCORE");
    const notifyobj = commonAPI.getChileAuthList(childAuth, "MENU03"); //涉旅企业诚信
    if (notifyobj) {
      const childList = notifyobj.children;
      if (childList && childList.length > 0) {
        // for (let i = 0; i < childList.length; i++) {
        // 拿任意 类型数据的按钮权限集合。
        this.addAuth = "";
        this.updateAuth = "";
        this.deleteAuth = "";
        this.userAuthoirese = "";
        const btnList = childList[0].operationType;
        console.log("------按钮权限;", btnList);
        if (btnList) {
          for (let j = 0; j < btnList.length; j++) {
            if (btnList[j].value === "OPERATION01") {
              this.addAuth = "OPERATION01"; //新增
            }
            if (btnList[j].value === "OPERATION02") {
              this.updateAuth = "OPERATION02"; //编辑
            }
            if (btnList[j].value === "OPERATION03") {
              this.deleteAuth = "OPERATION03"; //删除
            }
            if (btnList[j].value === "OPERATION06") {
              this.userAuthoirese = "OPERATION06";
            }
          }
        }

        // }
      }
    }
    this.initData();
  },
  computed: {
    /** 列表中是否有已审核的项，有已审核的项就显示扣分，不管扣分是否为 0 **/
    isShowDeduction() {
      return this.accidentList.map((e) => e.audited).includes(1);
    },
  },
  methods: {
    /** 获取列表 **/
    async initData() {
      const res = await api.getIntegrityList({
        year: this.year,
        quarter: this.quarter,
        area: this.area,
      });
      if (res.ret === 0) {
        this.accidentList = res.data.assessApiVOS;
        this.deduction = (res.data.deduction / 100).toFixed(2);
        this.score = (res.data.score / 100).toFixed(2);
        this.sumScore = (res.data.sumScore / 100).toFixed(1);
      }
    },
    // 新增
    addSituation() {
      this.$router.push({
        path: "/appraise/addCredit",
        query: {
          year: this.year,
          quarter: this.quarter,
          area: this.area,
        },
      });
    },
    // 查看详情
    goDetail(item) {
      const _this = this;
      const params = commonAPI.getJsonLocal("creditlistparams");
      if (params) {
        commonAPI.removeJsonLocal("creditlistparams");
      }
      commonAPI.setJsonLocal("creditlistparams", {
        // area: item.area ?? this.area,
        ...item,
        areaName: item.areaName ?? this.areaName,
        integrityType: item.integrityType,
        quarter: item.quarter ?? this.quarter,
        year: item.year ?? this.year,
        updateAuth: this.updateAuth,
        deleteAuth: this.deleteAuth,
        userAuthoirese: this.userAuthoirese,
      });
      this.$router.push({
        path: "/appraise/creditDetail",
        query: {
          ...item,
          areaName: item.areaName ?? this.areaName,
          quarterName: this.$route.query.quarterName,
          year: this.year,
          quarter: this.quarter
          // integrityType: item.integrityType,
          // quarter: item.quarter,
          // year: item.year,
          // updateAuth: this.updateAuth,
          // deleteAuth: this.deleteAuth,
          // userAuthoirese: this.userAuthoirese,

        },
      });
    },
  },
};
</script>

<style scoped lang="less">
.deduct_list {
  height: 100%;
  background-color: #fbfbfb;
}

.head {
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
  width: 100%;
  height: 96px;
  background-color: #fff;
}

.head_left {
  padding-top: 20px;
  width: 276px;
  color: #333;
  font-size: 20px;
  line-height: 28px;
  font-weight: bold;
}

.head_right {
  .score {
    padding: 22px 0 8px;
    color: #ff4d4d;
    font-size: 22px;
    line-height: 22px;
    font-weight: 500;
    text-align: right;
  }

  .score.gray {
    color: #999;
  }

  .percent {
    font-size: 14px;
    font-weight: 500;
    color: #999;
  }
}

.save_list {
  padding: 0 12px;

  .list_top {
    display: flex;
    justify-content: space-between;
  }

  .add_btn {
    margin: 24px 0 12px;
    width: 70px;
    height: 30px;

    span {
      line-height: 30px;
    }

    .plus {
      padding-right: 3px;
      line-height: 28px;
      vertical-align: top;
    }
  }

  .plus {
    padding-right: 3px;
    line-height: 30px;
    vertical-align: top;
  }

  .total {
    margin: 32px 0 20px;
    font-size: 14px;
    font-weight: 400;
    color: #333;

    span {
      color: #ff8c19;
      font-weight: 500;
    }
  }

  .record_list {
    background: #fff;
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.04);
    border-radius: 3px;
  }

  .record_item {
    padding: 16px;
    border-bottom: 1px solid #eee;

    .record_title {
      display: flex;
      justify-content: space-between;
      margin-bottom: 16px;
      color: #333;
      font-size: 14px;
      font-weight: 600;

      .title {
        font-size: 14px;
        font-weight: bold;
      }

      .deduct_score {
        color: #ff4d4d;
      }

      .status {
        font-size: 12px;
        color: #ff8c19;
      }
    }

    &:last-child {
      border: 0;
    }

    .reason {
      margin-bottom: 8px;
      font-size: 12px;
      color: #666;
      display: flex;
      padding: 2px 0 0 0;
      margin-top: -2px;
    }

    .fmemo {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 75%;
      display: inline-block;
      padding: 3px 0 0 0;
      margin-top: -3px;
    }

    .see_more {
      padding-top: 8px;
      font-size: 12px;
      color: #36b374;

      img {
        margin-left: 2px;
        display: inline-block;
        width: 12px;
        height: 12px;
        vertical-align: top;
      }
    }
  }
}

.no_data {
  .no_data_img {
    padding: 72px 0 20px;

    img {
      margin: 0 auto;
      width: 74px;
      height: 62px;
    }
  }

  .no_data_tip {
    line-height: 22px;
    font-size: 14px;
    color: #999;
    text-align: center;
  }

  .add_btn_box {
    padding: 32px 0;
    background-color: transparent;
    text-align: center;

    .add_btns {
      width: 70px;
      height: 30px;

      span {
        line-height: 30px;
      }

      .plus {
        padding-right: 3px;
        line-height: 28px;
        vertical-align: top;
      }
    }
  }
}
</style>
